import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './Servicios.css';

function Servicios() {
  const whatsappUrl = 'https://wa.me/50686191589?text=' + encodeURIComponent('Hola Gabriela, me gustaría solicitar información sobre sus servicios de consultoría en vainilla.');

  return (
    <div className="servicios-page">
      <Helmet>
        <title>Consultoría y Servicios Especializados | Sol de Vainilla</title>
        <meta
          name="description"
          content="Servicios de consultoría en plantaciones de vainilla, evaluación de inversiones, planes de manejo integrado contra plagas y buenas prácticas agrícolas en Costa Rica, México, Guatemala, Honduras, Nicaragua y otros países de la región."
        />
      </Helmet>

      {/* Hero Header */}
      <section
        className="servicios-hero"
        style={{
          backgroundImage:
            "radial-gradient(circle at center, rgba(14, 25, 12, 0.65) 0%, rgba(10, 18, 9, 0.9) 100%), url('/field1.jpeg')",
        }}
      >
        <div className="servicios-hero-container">
          <span className="servicios-hero-badge">Asesoría Biotecnología</span>
          <h1>Consultoría Especializada en Vainilla</h1>
          <p>
            Acompañamos a productores, inversionistas y empresas agropecuarias en el desarrollo,
            optimización y rentabilidad de plantaciones de vainilla (<em>Vanilla planifolia</em>) con
            estándares científicos de clase mundial.
          </p>
          <div className="servicios-hero-actions">
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="servicios-cta-primary">
              Agendar Asesoría Técnica
            </a>
            <Link to="/contacto" className="servicios-cta-secondary">
              Enviar Solicitud
            </Link>
          </div>
        </div>
      </section>

      {/* 4 Core Consulting Services */}
      <section className="servicios-pillars-section">
        <div className="container">
          <div className="section-title-wrapper">
            <h2>Nuestros Servicios de Consultoría</h2>
            <p>Soluciones integrales respaldadas por la ciencia para cada etapa de su proyecto de vainilla.</p>
          </div>

          <div className="services-grid">
            {/* 1. Consultoría en Plantaciones */}
            <div className="service-card">
              <div className="service-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22v-9" />
                  <path d="M9 15c-3-1-5.5-4-5.5-7.5C3.5 4 6.5 2 12 2s8.5 2 8.5 5.5c0 3.5-2.5 6.5-5.5 7.5" />
                  <path d="M12 13c-2 0-3.5 1-4.5 2" />
                  <path d="M12 13c2 0 3.5 1 4.5 2" />
                </svg>
              </div>
              <h3>Consultoría Integral en Plantaciones</h3>
              <p className="service-card-desc">
                Diseño, establecimiento y manejo de plantaciones bajo sombra natural (sistemas agroforestales) o mallasombra tecnificada.
              </p>
              <ul className="service-card-list">
                <li>Selección de esquejes y material vegetal de alta sanidad genética.</li>
                <li>Elección y manejo de tutores vivos e inertes.</li>
                <li>Planes de nutrición de precisión, riego y manejo de sustratos orgánicos.</li>
                <li>Técnicas de inducción floral y polinización manual de alto rendimiento.</li>
                <li>Acompañamiento en procesos de beneficiado tradicional y beneficiado gourmet.</li>
              </ul>
            </div>

            {/* 2. Planes contra Plagas y Enfermedades */}
            <div className="service-card">
              <div className="service-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
              </div>
              <h3>Planes de Manejo Integrado contra Plagas (MIPE)</h3>
              <p className="service-card-desc">
                Estrategias de bioseguridad y control fitosanitario para prevenir y erradicar las principales amenazas patológicas de la vainilla.
              </p>
              <ul className="service-card-list">
                <li>Diagnóstico temprano y contención de <em>Fusarium oxysporum f. sp. vanillae</em> (pudrición de raíz y tallo).</li>
                <li>Protocolos de monitoreo preventivo de plagas (chinches, trips, caracoles).</li>
                <li>Uso de bioinsumos, microorganismos benéficos e inductores de resistencia vegetal.</li>
                <li>Capacitación en desinfección de herramientas y bioseguridad fitosanitaria en campo.</li>
              </ul>
            </div>

            {/* 3. Buenas Prácticas Agrícolas */}
            <div className="service-card">
              <div className="service-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="8" r="7" />
                  <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
                </svg>
              </div>
              <h3>Buenas Prácticas Agrícolas (BPA) y Capacitación</h3>
              <p className="service-card-desc">
                Implementación de metodologías sostenibles e inocuas que preparan a las plantaciones para certificaciones internacionales y mercados premium.
              </p>
              <ul className="service-card-list">
                <li>Implementación de protocolos de inocuidad y trazabilidad de campo a empaque.</li>
                <li>Gestión agroecológica respetuosa con la biodiversidad y el suelo vivo.</li>
                <li>Talleres prácticos de capacitación presencial y virtual para equipos de campo.</li>
                <li>Estandarización de cosechas en punto óptimo de madurez química.</li>
                <li>Manuales de procedimientos operativos estandarizados (POEs) a la medida.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Gabriela Rodriguez Profile Section */}
      <section className="servicios-expert-section" id="sobre-gabriela">
        <div className="container">
          <div className="expert-bio-wrapper">
            <div className="expert-bio-header">
              <div className="expert-photo-container">
                <img src="/gabriela-rodriguez.jpg" alt="Gabriela Rodríguez Hernández" className="expert-bio-photo" />
                <span className="expert-photo-tag">Consultora Internacional</span>
              </div>
              <div className="expert-bio-intro">
                <h2>Gabriela Rodríguez Hernández</h2>
                <p className="expert-bio-subtitle">Bióloga con énfasis en Biotecnología | Especialista en Vainilla</p>
                <div className="expert-badges">
                  <span className="expert-badge">+10 Años de Experiencia</span>
                  <span className="expert-badge">Investigación Molecular</span>
                  <span className="expert-badge">Biotecnología Agrícola</span>
                </div>
              </div>
            </div>

            <div className="expert-international-highlight">
              <div className="intl-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
              </div>
              <div className="intl-content">
                <h4>Experiencia Internacional en Plantaciones</h4>
                <p>
                  Gabriela ha realizado consultorías especializadas, diagnósticos y capacitaciones en plantaciones de{' '}
                  <strong>México, Guatemala, Honduras, Nicaragua y Costa Rica</strong>, adaptando exitosamente los protocolos técnicos a los diversos microclimas y condiciones edáficas de Mesoamérica.
                </p>
              </div>
            </div>

            <div className="expert-bio-body">
              <p>
                Con más de una década dedicada al estudio botánico, la propagación in vitro, la caracterización molecular y el manejo de la vainilla (<em>Vanilla planifolia</em>), Gabriela combina el rigor científico con una profunda experiencia práctica en finca.
              </p>
              <p>
                Ha colaborado con productores independientes, cooperativas e inversionistas agrícolas para resolver desafíos fitosanitarios complejos, optimizar la polinización manual y transformar cosechas en vainilla gourmet de calidad de exportación.
              </p>
            </div>

            <div className="expert-credentials-grid">
              {/* Formación Académica */}
              <div className="credential-block">
                <h3>Formación Académica</h3>
                <ul>
                  <li>
                    <strong>Bachillerato en Biología con énfasis en Biotecnología</strong>
                    <span>Universidad Nacional (UNA), Heredia, Costa Rica</span>
                  </li>
                  <li>
                    <strong>Licenciatura en Gestión de Recursos Naturales</strong>
                    <span>Universidad Nacional (UNA), Heredia, Costa Rica</span>
                  </li>
                </ul>
              </div>

              {/* Trayectoria Profesional */}
              <div className="credential-block">
                <h3>Trayectoria y Liderazgo</h3>
                <ul>
                  <li>
                    <strong>Consultora Internacional de Vainilla</strong>
                    <span>Asesorías en diseño de plantaciones, sanidad y beneficiado en Centroamérica y México.</span>
                  </li>
                  <li>
                    <strong>Co-fundadora, Marca Comercial Vaiterra</strong>
                    <span>Impulso a la producción de vainilla sostenible y de alta pureza.</span>
                  </li>
                  <li>
                    <strong>Red Latinoamericana de Vainilla</strong>
                    <span>Participación en investigación y conservación de germoplasma.</span>
                  </li>
                </ul>
              </div>

              {/* Congresos y Conferencias */}
              <div className="credential-block full-width">
                <h3>Conferencias y Congresos Internacionales</h3>
                <div className="conferences-list">
                  <div className="conference-item">
                    <span className="conference-tag">México</span>
                    <p><strong>Ponente:</strong> III Congreso Internacional de Vainilla, Papantla, Veracruz, México.</p>
                  </div>
                  <div className="conference-item">
                    <span className="conference-tag">Guatemala</span>
                    <p><strong>Expositora:</strong> Conferencia Técnica Proceso y Cultivo de Vainilla, Escuintla, Guatemala.</p>
                  </div>
                  <div className="conference-item">
                    <span className="conference-tag">Costa Rica</span>
                    <p><strong>Ponente:</strong> I Seminario Internacional de Vainilla en Costa Rica, Heredia.</p>
                  </div>
                  <div className="conference-item">
                    <span className="conference-tag">Costa Rica</span>
                    <p><strong>Presentadora:</strong> I Congreso Internacional de Vainilla y Sistemas Agroforestales, Alajuela.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Direct CTA */}
            <div className="expert-cta-banner">
              <div className="expert-cta-text">
                <h3>¿Planea un proyecto de vainilla o busca optimizar su plantación?</h3>
                <p>Contáctenos directamente para coordinar una evaluación técnica preliminar con Gabriela Rodríguez.</p>
              </div>
              <div className="expert-cta-buttons">
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="expert-whatsapp-btn">
                  Consultar por WhatsApp
                </a>
                <Link to="/contacto" className="expert-contact-btn">
                  Formulario de Contacto
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Servicios;